/** Miroir de l'énumération PostgreSQL diagnostic_type. */
export const DIAGNOSTIC_TYPES = [
  'exportConfiguration',
  'diagnosticRapide',
  'diagnosticLong',
  'diagnosticExtreme',
] as const;

export type DiagnosticType = (typeof DIAGNOSTIC_TYPES)[number];

export const DIAGNOSTIC_TYPE_LABELS: Record<DiagnosticType, string> = {
  exportConfiguration: 'Export de configuration',
  diagnosticRapide: 'Diagnostic rapide',
  diagnosticLong: 'Diagnostic long',
  diagnosticExtreme: 'Diagnostic extrême',
};

export function diagnosticTypeLabel(type: string): string {
  return DIAGNOSTIC_TYPE_LABELS[type as DiagnosticType] ?? type;
}

/** Formats acceptés à l'import par ce lot. */
export const ACCEPTED_UPLOAD_ACCEPT = '.pdf,.html,.htm,.txt,.log';

const FILE_FORMAT_LABELS: Record<string, string> = {
  pdf: 'PDF',
  html: 'HTML',
  txt: 'Texte',
};

export function fileFormatLabel(format: string): string {
  return FILE_FORMAT_LABELS[format] ?? format.toUpperCase();
}

/**
 * Un rapport texte est rendu par le navigateur en police à chasse fixe sur
 * fond clair ; le cadre s'accorde à ce rendu. Choix d'affichage seulement : le
 * type de contenu servi, lui, vient du format enregistré en base.
 */
export function isMonospaceFormat(format: string): boolean {
  return format === 'txt';
}

/** Libellés des champs de configuration, extraits ou saisis. */
export const CONFIGURATION_LABELS: Record<string, string> = {
  processeur: 'Processeur',
  carteGraphique: 'Carte graphique',
  memoire: 'Mémoire',
  disques: 'Disques',
};
